import { ApartmentIcon } from './ApartmentIcon';
import { BuildingIcon } from './BuildingIcon';
import { BuildingInCartIcon } from './BuildingInCartIcon';
import { BuildingUnderConstructionIcon } from './BuildingUnderConstructionIcon';
import { BuildingWithQuestionMarkIcon } from './BuildingWithQuestionMarkIcon';
import { CraneIcon } from './CraneIcon';
import { HouseIcon } from './HouseIcon';
import { HouseWithQuestionMarkIcon } from './HouseWithQuestionMarkIcon';
import { InfoOutlinedIcon } from './InfoOutlinedIcon';
import { KeysIcon } from './KeysIcon';
import { LandIcon } from './LandIcon';
import { MultifamilyHouseIcon } from './MultifamilyHouseIcon';
import { OneStarIcon } from './OneStarIcon';
import { PenthouseIcon } from './PenthouseIcon';
import { PhoneIcon } from './PhoneIcon';
import { SliderThumbIcon } from './SliderThumbIcon';
import { CalendarIcon } from './CalendarIcon';
import { CheckmarkIcon } from './CheckmarkIcon';
import { CheckmarkIconColored } from './CheckmarkIconColored';
import { ClockIcon } from './ClockIcon';
import { ChevronLeft } from './ChevronLeft';
import { ChevronRight } from './ChevronRight';
import { StallIcon } from './StallIcon';
import { ThreeStarsIcon } from './ThreeStarsIcon';
import { TownhouseIcon } from './TownhouseIcon';
import { TractorIcon } from './TractorIcon';
import { TwoBuildingsIcon } from './TwoBuildingsIcon';
import { TwoFamilyHouseIcon } from './TwoFamilyHouseIcon';
import { TwoSmallHousesIcon } from './TwoSmallHousesIcon';
import { TwoStarsIcon } from './TwoStarsIcon';
import { CaretDownIcon } from './CaretDownIcon';
import { CloseIcon } from './CloseIcon';
import { LocationIcon } from './LocationIcon';
import { BurgerMenuIcon } from './BurgerMenuIcon';
import { FilterIcon } from './FilterIcon';
import { SuccessIcon } from './SuccessIcon';
import { MapFullscreenIcon } from './MapFullscreenIcon';
import { FavoritesIcon } from './FavoritesIcon';
import { ListIcon } from './ListIcon';
import { SquareDottedIcon } from './SquareDottedIcon';
import { CaretRightIcon } from './CaretRightIcon';
import { ArrowBackIcon } from './ArrowBackIcon';
import { NavigationIcon } from './NavigationIcon';
import { CancelIcon } from './CancelIcon';
import { StarCircleIcon } from './StarCircleIcon';
import { StarCircleColoredIcon } from './StarCircleColoredIcon';
import { FreeIcon } from './FreeIcon';
import { RentedIcon } from './RentedIcon';
import { HalfRentedIcon } from './HalfRentedIcon';
import { OwnUseIcon } from './OwnUseIcon';
import { ActingOnBehalfIcon } from './ActingOnBehalfIcon';
import { AndereIcon } from './AndereIcon';
import { AppartmentHouseIcon } from './AppartmentHouseIcon';
import { AppartmentIcon } from './AppartmentIcon';
import { AsapIcon } from './AsapIcon';
import { Asap1Icon } from './Asap1Icon';
import { Asap2Icon } from './Asap2Icon';
import { Asap3Icon } from './Asap3Icon';
import { AverageIcon } from './AverageIcon';
import { BasicIcon } from './BasicIcon';
import { BaujahrIcon } from './BaujahrIcon';
import { BaulandIcon } from './BaulandIcon';
import { BestIcon } from './BestIcon';
import { CommercialIcon } from './CommercialIcon';
import { DivorceIcon } from './DivorceIcon';
import { EgIcon } from './EgIcon';
import { FarmlandIcon } from './FarmlandIcon';
import { FrameIcon } from './FrameIcon';
import { FullyDevelopedIcon } from './FullyDevelpedIcon';
import { GescheftshausIcon } from './GescheftshausIcon';
import { HouseSqIcon } from './HouseSqIcon';
import { IndustrialIcon } from './IndustrialIcon';
import { InheritIcon } from './InheritIcon';
import { KaufenIcon } from './KaufenIcon';
import { LandSqIcon } from './LandSqIcon';
import { MarketIcon } from './MarketIcon';
import { MailOutlineFilled } from './MailOutlineFilled';
import { MehrfamilienHouseIcon } from './MehrfamilienHouseIcon';
import { MovedIcon } from './MovedIcon';
import { NotDevelopedIcon } from './NotDevelopedIcon';
import { NotOwningIcon } from './NotOwningIcon';
import { NotSure1Icon } from './NotSure1Icon';
import { NotSureIcon } from './NotSureIcon';
import { OwningIcon } from './OwningIcon';
import { PartiallyDevelopedIcon } from './PartiallyDevelopedIcon';
import { PensionIcon } from './PensionIcon';
import { PraxisIcon } from './PraxisIcon';
import { RoomsSqIcon } from './RoomsSqIcon';
import { SonstigeIcon } from './SonstigeIcon';
import { TotalFlatSqIcon } from './TotalFlatSqIcon';
import { VerkaufenIcon } from './VerkaufenIcon';
import { WaldIcon } from './WaldIcon';
import { AvgSMPricePerRegionIcon } from './AvgSMPricePerRegionIcon';
import { NrofBrokersPerRegion } from './NrofBrokersPerRegion';
import { SellingHorizon } from './SellingHorizon';
import { EmptyCircleIcon } from './EmptyCircleIcon';
import { CheckedCircleIcon } from './CheckedCircleIcon';
import { QuestionMarkIcon } from './QuestionMarkIcon';
import { EsclamationIcon } from './EsclamationIcon';
import { ArrowDown } from './ArrowDown';
import { SaleHorizon1Icon } from './SaleHorizon1Icon';
import { SaleHorizon4Icon } from './SaleHorizon4Icon';
import { Menu } from './Menu';
import { PhoneFilled } from './PhoneFilled';
import { ArrowDownMenu } from './ArrowDownMenu';
import { ArrowUpMenu } from './ArrowUpMenu';
import { Account } from './Account';
import { AgentPlaceholder } from './AgentPlaceholder';
import { PhoneButtonIcon } from './PhoneButtonIcon';
import { LocationFilled } from '@toolbox/components/Icon/icons/LocationFilled';
import { Calendar } from './Calendar';
import { Clock } from './Clock';
import { OpenInNewFilled } from './OpenInNewFilled';
import { HandShakeIcon } from './HandShakeIcon';
import { MarketTrendIcon } from './MarketTrendIcon';
import { SquareMeterIcon } from './SquareMeterIcon';

export const icons = {
  wald: WaldIcon,
  verkaufen: VerkaufenIcon,
  'total-flat-sq': TotalFlatSqIcon,
  sonstige: SonstigeIcon,
  'rooms-sq': RoomsSqIcon,
  praxis: PraxisIcon,
  pension: PensionIcon,
  'partially-developed': PartiallyDevelopedIcon,
  owning: OwningIcon,
  'not-sure': NotSureIcon,
  'not-sure-1': NotSure1Icon,
  'not-owning': NotOwningIcon,
  'not-developed': NotDevelopedIcon,
  moved: MovedIcon,
  'mehrfamilien-house': MehrfamilienHouseIcon,
  market: MarketIcon,
  'land-sq': LandSqIcon,
  kaufen: KaufenIcon,
  inherit: InheritIcon,
  industrial: IndustrialIcon,
  'house-sq': HouseSqIcon,
  gescheftshaus: GescheftshausIcon,
  'fully-developed': FullyDevelopedIcon,
  frame: FrameIcon,
  farmland: FarmlandIcon,
  eg: EgIcon,
  divorce: DivorceIcon,
  commercial: CommercialIcon,
  best: BestIcon,
  bauland: BaulandIcon,
  baujahr: BaujahrIcon,
  basic: BasicIcon,
  average: AverageIcon,
  asap: AsapIcon,
  'asap-1': Asap1Icon,
  'asap-2': Asap2Icon,
  'asap-3': Asap3Icon,
  appartment: AppartmentIcon,
  'appartment-house': AppartmentHouseIcon,
  andere: AndereIcon,
  'acting-on-behalf': ActingOnBehalfIcon,
  free: FreeIcon,
  rented: RentedIcon,
  'half-rented': HalfRentedIcon,
  'own-use': OwnUseIcon,
  'arrow-back': ArrowBackIcon,
  'caret-down': CaretDownIcon,
  'caret-right': CaretRightIcon,
  'star-circle-colored': StarCircleColoredIcon,
  'star-circle': StarCircleIcon,
  burger: BurgerMenuIcon,
  close: CloseIcon,
  cancel: CancelIcon,
  success: SuccessIcon,
  location: LocationIcon,
  favorites: FavoritesIcon,
  list: ListIcon,
  navigation: NavigationIcon,
  'square-dotted': SquareDottedIcon,
  'house-with-question-mark': HouseWithQuestionMarkIcon,
  apartment: ApartmentIcon,
  'two-stars': TwoStarsIcon,
  'one-star': OneStarIcon,
  'three-stars': ThreeStarsIcon,
  stall: StallIcon,
  building: BuildingIcon,
  tractor: TractorIcon,
  'two-buildings': TwoBuildingsIcon,
  house: HouseIcon,
  'two-small-houses': TwoSmallHousesIcon,
  'building-in-cart': BuildingInCartIcon,
  land: LandIcon,
  'multifamily-house': MultifamilyHouseIcon,
  crane: CraneIcon,
  'building-under-construction': BuildingUnderConstructionIcon,
  penthouse: PenthouseIcon,
  'building-with-question-mark': BuildingWithQuestionMarkIcon,
  phone: PhoneIcon,
  townhouse: TownhouseIcon,
  'two-family-house': TwoFamilyHouseIcon,
  keys: KeysIcon,
  'info-outlined': InfoOutlinedIcon,
  'slider-thumb': SliderThumbIcon,
  calendar: CalendarIcon,
  clock: ClockIcon,
  checkmark: CheckmarkIcon,
  checkmarkColored: CheckmarkIconColored,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  'filter-icon': FilterIcon,
  'map-fullscreen-icon': MapFullscreenIcon,
  avgSMPricePerRegionIcon: AvgSMPricePerRegionIcon,
  nrofBrokersPerRegion: NrofBrokersPerRegion,
  sellingHorizon: SellingHorizon,
  EmptyCircleIcon,
  CheckedCircleIcon,
  QuestionMarkIcon,
  EsclamationIcon,
  arrowDown: ArrowDown,
  SaleHorizon1Icon,
  SaleHorizon4Icon,
  Menu,
  PhoneFilled,
  ArrowDownMenu,
  ArrowUpMenu,
  Account,
  AgentPlaceholder,
  PhoneButtonIcon,
  LocationFilled,
  Calendar,
  Clock,
  MailOutlineFilled,
  OpenInNewFilled,
  HandShakeIcon,
  MarketTrendIcon,
  SquareMeterIcon,
};

export type IconName = keyof typeof icons;
